// extracted by mini-css-extract-plugin
module.exports = {"atom__tab-container":"styles_atom__tab-container__Ww7UI","selected":"styles_selected__KgpOO"};